export default "__VITE_ASSET__2261bcf4__"